function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_ucc-1",
  d: "M297.91,431.81a11.23,11.23,0,0,0,11.22-11.22h-2a9.22,9.22,0,1,1-1.57-5.14l1.66-1.12a11.22,11.22,0,1,0-9.31,17.48Z",
  transform: "translate(-286.69 -409.38)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#6c6c70",
  className: "a_ucc-1",
  points: "19.38 5 19.38 0.06 21.38 0.06 21.38 5 21.38 7 19.38 7 14.44 7 14.44 5 19.38 5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_ucc-1",
  d: "M297.71,421.46a2.95,2.95,0,1,1,2.95-2.95A2.95,2.95,0,0,1,297.71,421.46Zm0-4.78a1.83,1.83,0,1,0,1.83,1.83A1.83,1.83,0,0,0,297.71,416.68Z",
  transform: "translate(-286.69 -409.38)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6c6c70",
  className: "a_ucc-1",
  d: "M293.46,425.34a4.26,4.26,0,0,1,8.49,0,6.88,6.88,0,0,0,1-.94,5.37,5.37,0,0,0-10.42,0A6.88,6.88,0,0,0,293.46,425.34Z",
  transform: "translate(-286.69 -409.38)"
});

var SvgUserRefresh = function SvgUserRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.44 22.44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_refresh.0f02d556.svg";
export { ForwardRef as ReactComponent };